import { Box, Grid, Icon, Text } from '@chakra-ui/react';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { BsExclamationCircleFill } from 'react-icons/bs';

import { FlagCountryFromLanguage } from '../../constants';

interface LanguageHighlightProps {
  workshopLanguage: string;
  applyAnnimation: boolean;
}

export const LanguageHighlight = ({ workshopLanguage, applyAnnimation }: LanguageHighlightProps) => {
  const { t } = useTranslation();

  return (
    <Grid display="flex" py="0.5em">
      <Grid display={'flex'}>
        <Icon
          style={{
            transform: applyAnnimation ? 'scale(2.1)' : 'scale(1.2)',
            transition: 'transform .5s ease-in-out',
            display: 'flex',
          }}
          as={BsExclamationCircleFill}
          boxSize={6}
          color={applyAnnimation ? 'red.500' : 'gray.400'}
          mr="1em"
          ml="1em"
        />
        <Text display="inline" fontWeight={'bold'}>
          {t('workshop:language.required') + ':'}
        </Text>
      </Grid>
      <Box>
        {' '}
        <Text display="inline" fontWeight={'bold'}>
          {workshopLanguage ? t(`location:languages.${workshopLanguage.toUpperCase()}`) : '-'}
        </Text>
        <ReactCountryFlag
          //@ts-ignore
          countryCode={FlagCountryFromLanguage[workshopLanguage?.toUpperCase()]}
          svg
          style={{
            marginLeft: '1em',
            marginRight: '.5em',
            width: '2em',
            height: '2em',
          }}
        />
      </Box>
    </Grid>
  );
};
